(function () {
  var _sectionEl = document.querySelector('[data-editorial-grid]');
  var SECTION_ID = _sectionEl ? (_sectionEl.getAttribute('data-section-id') || '') : '';
  var GRID_ID = 'tpl-product-grid';

  function swapGridFromHtml(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = parsed.querySelector('#' + GRID_ID);
    var currentGrid = document.getElementById(GRID_ID);
    if (newGrid && currentGrid) {
      currentGrid.innerHTML = newGrid.innerHTML;
      // Swapped items miss the IntersectionObserver in tpl-animations.js and
      // would otherwise stay at opacity:0 forever. Reveal the grid + items.
      currentGrid.classList.add('is-visible');
      currentGrid.querySelectorAll('[data-tpl-animate]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      // Perf 2026-09-11: hover images arrive deferred (data-tpl-defer-src).
      // Hover-capable devices hydrate the fresh grid now so the first hover
      // fade never shows a blank; phones keep hydrating on touch.
      if (window.TPLHydrateDeferred && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        window.TPLHydrateDeferred(currentGrid);
      }
      // Fix 2026-10-05: in room view the deferred image is the one on screen,
      // on touch devices too — the hover gate above never reaches them, so the
      // freshly sorted grid rendered blank. No-op while the shopper is on Artwork.
      if (window.TPLHydrateRoomImages) window.TPLHydrateRoomImages(currentGrid);
    }
  }

  function fetchAndSwap(url) {
    var sectionUrl = new URL(url.toString());
    sectionUrl.searchParams.set('section_id', SECTION_ID);
    return fetch(sectionUrl.toString())
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(swapGridFromHtml)
      .catch(function (err) {
        // Network/parse failure: leave existing grid in place and reveal it so the
        // shopper never sees a blank section. Restore the URL is handled by caller.
        if (window.console) console.warn('tpl-collection-product-grid: sort fetch failed', err);
        var currentGrid = document.getElementById(GRID_ID);
        if (currentGrid) currentGrid.classList.add('is-visible');
      });
  }

  function init() {
    var sel = document.getElementById('tpl-sort-select');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      history.pushState({ tplSort: this.value }, '', url);
      fetchAndSwap(url);
    });
  }

  window.addEventListener('popstate', function () {
    var sel = document.getElementById('tpl-sort-select');
    var url = new URL(window.location.href);
    var sortBy = url.searchParams.get('sort_by');
    if (sel && sortBy) sel.value = sortBy;
    fetchAndSwap(url);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Scroll preservation for filter pill clicks.
     Pills are plain <a href> tags (they navigate to /collections/X/tag),
     so we save scrollY on click and restore it on the next page load. */
  try { history.scrollRestoration = 'manual'; } catch (_) {}

  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('[data-tpl-filter-pills] a');
    if (!pill) return;
    try {
      sessionStorage.setItem('tpl-cpg-scroll', String(window.scrollY));
      sessionStorage.setItem('tpl-cpg-scroll-ts', String(Date.now()));
    } catch (_) {}
  }, true);

  function restoreScroll() {
    try {
      var y = sessionStorage.getItem('tpl-cpg-scroll');
      var ts = parseInt(sessionStorage.getItem('tpl-cpg-scroll-ts') || '0', 10);
      // Only restore if saved within last 10s (prevents stale restores)
      if (y !== null && Date.now() - ts < 10000) {
        window.scrollTo(0, parseInt(y, 10));
      }
      sessionStorage.removeItem('tpl-cpg-scroll');
      sessionStorage.removeItem('tpl-cpg-scroll-ts');
    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScroll);
  } else {
    restoreScroll();
  }
})();
